import $ from 'jquery';
import { request } from '../utils/request';

var APPLET_SESSION = 'AppletSession';

export function sendOSInfo() {
  var dfd = $.Deferred();

  if (!$.browser.msie) {
    dfd.resolve();
    return;
  }

  var AX = document.getElementById(APPLET_SESSION);
  var osInfo = AX && AX.osinfo;

  if (!osInfo) {
    dfd.resolve();
    return;
  }

  var usn = $('.app__initial-state').data('usn');
  var game = $('.app__initial-state').data('game');
  var data = $.parseJSON(osInfo);

  if (data.error) {
    dfd.resolve();
    return;
  }

  if (data.OSMajor == 5 && (data.OSMinor == 1 || data.OSMinor == 2)) {
    var ieCheck = 1; // 위에서 체크하므로 항상 IE
    var ieVer = $.browser.versionNumber;
    var strData = [
      data.OSMajor,
      data.OSMinor,
      data.SPMajor,
      data.SPMinor,
      data.SPName,
      ieCheck,
      ieVer,
      usn
    ].join('|');

    request(game, 'os-info', {
      method: 'POST',
      body: {
        payload: strData
      }
    }).then(dfd.resolve);
  }

  return dfd.promise();
}
